var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisualstudiocode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8666 3.44933L24.28 0.280001C23.9077 0.100743 23.489 0.0416614 23.0817 0.110939C22.6744 0.180216 22.2987 0.374423 22.0066 0.666667L9.3933 12.1733L3.89997 8.00267C3.65213 7.81469 3.34632 7.71937 3.03557 7.73325C2.72482 7.74713 2.42872 7.86934 2.19864 8.07867L0.43597 9.68133C0.298611 9.8062 0.188838 9.95837 0.113681 10.1281C0.0385238 10.2978 -0.000362465 10.4814 -0.000487976 10.667C-0.000613488 10.8527 0.0380245 11.0363 0.112952 11.2061C0.18788 11.376 0.297446 11.5283 0.434637 11.6533L5.19864 16L0.434637 20.3467C0.297446 20.4717 0.18788 20.624 0.112952 20.7939C0.0380245 20.9637 -0.000613488 21.1473 -0.000487976 21.333C-0.000362465 21.5186 0.0385238 21.7022 0.113681 21.8719C0.188838 22.0416 0.298611 22.1938 0.43597 22.3187L2.19997 23.92C2.43006 24.1293 2.72615 24.2515 3.0369 24.2654C3.34766 24.2793 3.65347 24.184 3.9013 23.996L9.39464 19.8253L22.008 31.332C22.2997 31.6243 22.6752 31.8186 23.0823 31.8879C23.4894 31.9571 23.908 31.898 24.28 31.7187L30.8693 28.5493C31.2083 28.3857 31.4943 28.1297 31.6943 27.8109C31.8943 27.492 32.0002 27.1231 32 26.7467V5.252C32 4.87529 31.8937 4.50622 31.6931 4.1873C31.4926 3.86838 31.2061 3.61258 30.8666 3.44933ZM24.0053 23.264L14.4346 16L24.0053 8.736V23.264Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisualstudiocode);
export default __webpack_public_path__ + "static/media/icon_visualstudiocode.def84441ff62a73366c52403d2762b7c.svg";
export { ForwardRef as ReactComponent };